export interface CrimeFilters {
  crimeTypes: {
    homicidio_doloso: boolean
    feminicidio: boolean
    secuestro: boolean
    extorsion: boolean
    robo_vehiculo: boolean
    robo_casa: boolean
    robo_negocio: boolean
    robo_transeunte: boolean
    lesiones_dolosas: boolean
    violencia_familiar: boolean
    violacion: boolean
    narcomenudeo: boolean
  }
  timeRange: {
    startDate: string
    endDate: string
  }
  state: string | null
}

export interface LocationData {
  id: string
  name: string
  state: string
  type: 'state' | 'municipality'
  coordinates: [number, number]
  crimeStats: CrimeStats
  population: number
  riskLevel: 'low' | 'medium' | 'high' | 'very_high'
}

export interface CrimeStats {
  total: number
  homicidio_doloso: number
  feminicidio: number
  secuestro: number
  extorsion: number
  robo_vehiculo: number
  robo_casa: number
  robo_negocio: number
  robo_transeunte: number
  lesiones_dolosas: number
  violencia_familiar: number
  violacion: number
  narcomenudeo: number
  rate_per_100k: number
  trend: 'up' | 'down' | 'stable'
  trend_percentage: number
}

export interface StateData {
  id: string
  name: string
  abbr: string
  totalCrimes: number
  crimeRate: number
  population: number
  municipalities: number
}

export interface MunicipalityData {
  id: string
  name: string
  stateId: string
  stateName: string
  totalCrimes: number
  crimeRate: number
  population: number
  coordinates: [number, number]
}

export interface CrimeType {
  id: string
  name: string
  nameEs: string
  color: string
  count: number
}

export const CRIME_TYPES: Record<string, CrimeType> = {
  homicidio_doloso: {
    id: 'homicidio_doloso',
    name: 'Intentional Homicide',
    nameEs: 'Homicidio Doloso',
    color: '#ff4757',
    count: 0,
  },
  feminicidio: {
    id: 'feminicidio',
    name: 'Femicide',
    nameEs: 'Feminicidio',
    color: '#ff6b81',
    count: 0,
  },
  secuestro: {
    id: 'secuestro',
    name: 'Kidnapping',
    nameEs: 'Secuestro',
    color: '#ffa502',
    count: 0,
  },
  extorsion: {
    id: 'extorsion',
    name: 'Extortion',
    nameEs: 'Extorsión',
    color: '#ff7f50',
    count: 0,
  },
  robo_vehiculo: {
    id: 'robo_vehiculo',
    name: 'Vehicle Theft',
    nameEs: 'Robo de Vehículo',
    color: '#3742fa',
    count: 0,
  },
  robo_casa: {
    id: 'robo_casa',
    name: 'Home Burglary',
    nameEs: 'Robo a Casa',
    color: '#2ed573',
    count: 0,
  },
  robo_negocio: {
    id: 'robo_negocio',
    name: 'Business Robbery',
    nameEs: 'Robo a Negocio',
    color: '#1e90ff',
    count: 0,
  },
  robo_transeunte: {
    id: 'robo_transeunte',
    name: 'Street Robbery',
    nameEs: 'Robo a Transeúnte',
    color: '#5352ed',
    count: 0,
  },
  lesiones_dolosas: {
    id: 'lesiones_dolosas',
    name: 'Assault',
    nameEs: 'Lesiones Dolosas',
    color: '#a55eea',
    count: 0,
  },
  violencia_familiar: {
    id: 'violencia_familiar',
    name: 'Domestic Violence',
    nameEs: 'Violencia Familiar',
    color: '#fd79a8',
    count: 0,
  },
  violacion: {
    id: 'violacion',
    name: 'Rape',
    nameEs: 'Violación',
    color: '#e84393',
    count: 0,
  },
  narcomenudeo: {
    id: 'narcomenudeo',
    name: 'Drug Dealing',
    nameEs: 'Narcomenudeo',
    color: '#00b894',
    count: 0,
  },
}

export const MEXICO_STATES = [
  { id: 'AGU', name: 'Aguascalientes' },
  { id: 'BCN', name: 'Baja California' },
  { id: 'BCS', name: 'Baja California Sur' },
  { id: 'CAM', name: 'Campeche' },
  { id: 'CHP', name: 'Chiapas' },
  { id: 'CHH', name: 'Chihuahua' },
  { id: 'CMX', name: 'Ciudad de México' },
  { id: 'COA', name: 'Coahuila' },
  { id: 'COL', name: 'Colima' },
  { id: 'DUR', name: 'Durango' },
  { id: 'GUA', name: 'Guanajuato' },
  { id: 'GRO', name: 'Guerrero' },
  { id: 'HID', name: 'Hidalgo' },
  { id: 'JAL', name: 'Jalisco' },
  { id: 'MEX', name: 'Estado de México' },
  { id: 'MIC', name: 'Michoacán' },
  { id: 'MOR', name: 'Morelos' },
  { id: 'NAY', name: 'Nayarit' },
  { id: 'NLE', name: 'Nuevo León' },
  { id: 'OAX', name: 'Oaxaca' },
  { id: 'PUE', name: 'Puebla' },
  { id: 'QUE', name: 'Querétaro' },
  { id: 'ROO', name: 'Quintana Roo' },
  { id: 'SLP', name: 'San Luis Potosí' },
  { id: 'SIN', name: 'Sinaloa' },
  { id: 'SON', name: 'Sonora' },
  { id: 'TAB', name: 'Tabasco' },
  { id: 'TAM', name: 'Tamaulipas' },
  { id: 'TLA', name: 'Tlaxcala' },
  { id: 'VER', name: 'Veracruz' },
  { id: 'YUC', name: 'Yucatán' },
  { id: 'ZAC', name: 'Zacatecas' },
]
